<template>
  <button
  :class="note?'shadow':''" :style="[
    {backgroundColor: color},
    image?{backgroundImage: `url(.${image})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}:{},
    position ? {backgroundPosition: position} : {},
    ImgSize ? {backgroundSize: ImgSize} : {}
  ]"
  @click="$emit('push')"
  >
    <div class="colorImage" ></div>
    <div>
      <div :style="[{
        color: color
      }]">{{name}}</div>
      <div>{{name_eng}}</div>
    </div>
    <div v-if="note" class="note">{{note}}</div>
  </button>
</template>

<script>
export default {
  props: ['name', 'name_eng', 'color', 'note', 'image', 'position', 'ImgSize'],
  data () {
    return {
      checked: false
    }
  }
}
</script>

<style lang="scss" scoped>
.colorImage {
  height: 110px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
button {
  &:disabled {
    filter: contrast(.8);
  }
  &.shadow {
    filter: contrast(.8);
  }
  display: grid;
  grid-template-rows: 1fr 80px;
  width: 276px;
  height: 190px;
  // background-color: var(--color-home-1);
  border-radius: 5px;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
  border: none;
  position: relative;
  box-sizing: border-box;
  &>div:not(.note):not(.colorImage) {
    width: 100%;
    height: 80px;
    background-color: #FFFFFF;
    position: absolute;
    bottom: 0;
    left: 0;
    border-radius: 0 0 5px 5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-inline: 18px;
    gap: 6px;
    box-sizing: border-box;
    &>div:nth-child(1) {
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0.15em;
    }
    &>div:nth-child(2) {
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */

      letter-spacing: 0.05em;
    }
  }
  .note {
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 80px;
    background-color: #99999980;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.15em;
    display: flex;
    align-items: center;
    padding-inline: 20px;
    font-weight: 900;
    color: #FFFFFFCD;
  }
}
</style>
